const f = 7, l = (_, s) => {
  if (s <= 7)
    return Array.from({
      length: s
    }, (E, i) => i + 1);
  const r = _ > 4, A = _ < s - 3;
  return r ? A ? [1, -1, _ - 1, _, _ + 1, -1, s] : [1, -1, ...Array.from({
    length: 5
  }, (E, i) => s - 4 + i)] : [1, 2, 3, 4, 5, -1, s];
};
export {
  f as DEFAULT_NUMBER_PAGE_TO_DISPLAY,
  l as getPageNumbers
};
